/**
 * yd-motion-v3: V3 整页动效底盘（GSAP + ScrollTrigger + Lenis，本地全局变量）。
 * 源自 web-hand-off motion-v3.js：import→window 全局；删 partials:loaded，补 shopify:section:load。
 * 1) Lenis 平滑滚动（驱动原生滚动，与 ScrollTrigger 集成，官方推荐写法：lenis.on('scroll', ScrollTrigger.update) + gsap.ticker）。
 * 2) 黑→白整页过渡：connect 段 [data-orbit] 滚至末段时 body 由 night 渐白，承接其后白区段（product 段已移除）。
 * 尊重 reduced-motion：不启 Lenis、不做动画。无 GSAP：整体 return。
 *
 * GSAP 评审优化（2026-06-14）：
 * - 删除失效的 rows() 死代码（选 .gest--cover .gest__row，本页 gestx 体系不存在该选择器）。
 * - product timeline 的 ScrollTrigger 带 id，shopify:section:unload 时 kill（Lenis 为全局单例，不在 section 卸载时销毁）。
 */
(function () {
  var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger, Lenis = window.Lenis;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot() {
    gsap = window.gsap; ScrollTrigger = window.ScrollTrigger; Lenis = window.Lenis;
    if (!gsap || !ScrollTrigger) return false;
    gsap.registerPlugin(ScrollTrigger);
    if (!reduce && Lenis && !window.kwLenis) {
      var lenis = new Lenis({ duration: 1.1, smoothWheel: true, anchors: true });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
      window.kwLenis = lenis;
    }
    return true;
  }

  function splitToChars(el) {
    var text = el.textContent;
    el.textContent = '';
    var out = [];
    for (var i = 0; i < text.length; i++) {
      var span = document.createElement('span');
      span.className = 'product__char';
      span.textContent = text[i] === ' ' ? ' ' : text[i];
      el.appendChild(span); out.push(span);
    }
    return out;
  }

  // 黑→白整页过渡：connect（最后一个深色段 [data-orbit]）滚动至末段时，body 由 night 渐白，
  // 使其后的白区段（health 起）平滑承接，无需依赖已移除的 product 段。scrub 跟随滚动。
  function bwTransition() {
    if (reduce || !gsap) return;
    var sec = document.querySelector('[data-orbit]');
    if (!sec || sec.dataset.bwReady) return;
    sec.dataset.bwReady = '1';
    var cs = getComputedStyle(document.documentElement);
    var night = cs.getPropertyValue('--kw-night').trim() || '#060505';
    var white = cs.getPropertyValue('--kw-white').trim() || '#ffffff';
    gsap.fromTo(document.body, { backgroundColor: night }, {
      backgroundColor: white, ease: 'none',
      scrollTrigger: { id: 'yd-bw-fade', trigger: sec, start: 'bottom 90%', end: 'bottom 40%', scrub: true, invalidateOnRefresh: true }
    });
  }

  function init() {
    if (!boot()) return;
    bwTransition(); ScrollTrigger.refresh();
  }
  function cleanup(e) {
    var sec = e && e.target ? e.target : null;
    if (!sec || !window.ScrollTrigger) return;
    var orbit = sec.querySelector('[data-orbit]');
    if (!orbit) return;                                 // 非 connect 段卸载，不处理（Lenis 全局单例保留）
    var st = ScrollTrigger.getById('yd-bw-fade');
    if (st) st.kill();
    delete orbit.dataset.bwReady;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', cleanup);
  window.addEventListener('load', function () { init(); if (window.ScrollTrigger) window.ScrollTrigger.refresh(); });
})();
